<vi-page [sidenavs]="true" [footer]="true" *ngIf="mapStore.state$ | async as state">
  <vi-progress-bar head [isLoading]="state.loading"></vi-progress-bar>

  <vi-content body *ngIf="state.loading">
    <vi-loader main [isLoading]="true" message=""></vi-loader>
  </vi-content>

  <div *ngIf="state.loaded" body class="container">
    <div class="map-container">
      <!-- search panel (only visible for desktop) -->
      <ng-container *ngIf="state.showSearch">
        <div class="search-panel lt-md:hidden">
          <div class="search-panel-header flex flex-row justify-between items-center">
            <h3>{{ '+INSTALLATIONS.MAP.ALL_INSTALLATIONS' | translate }}</h3>
            <button
              class="!hidden gt-md:!inline-flex"
              mat-stroked-button
              gtm="onGoToPage"
              gtmAction="Map"
              gtmCategory="sidenav"
              [routerLink]="['/installations']"
              routerLinkActive="active"
              (click)="onListViewSelection('/installations')"
            >
              <span>{{ '+INSTALLATIONS.MAP.LIST_VIEW' | translate }}</span>
            </button>
            <button
              class="list-btn-small gt-md:!hidden"
              mat-icon-button
              gtm="onGoToPage"
              gtmAction="Map"
              gtmCategory="sidenav"
              [routerLink]="['/installations']"
              routerLinkActive="active"
            >
              <mat-icon>toc</mat-icon>
            </button>
          </div>
          <div class="search-field">
            <app-installation-search
              [searchTerm]="searchTerm"
              (search)="mapStore.search($event)"
              (clear)="mapStore.clearSearch()"
              categoryForGtm="map"
            ></app-installation-search>
          </div>
          <div class="installation-list">
            <cdk-virtual-scroll-viewport
              class="virtual-scroll"
              itemSize="91"
              minBufferPx="200"
              maxBufferPx="400"
            >
              <div
                class="installation-item flex flex-row justify-between items-center"
                *cdkVirtualFor="let installation of state.searchedInstallations"
                gtm="onMapInstallationSelect"
                (click)="mapStore.selectInstallation(installation)"
              >
                <ng-container
                  *ngIf="mapStore.selectMainDevices(installation.id) | async as mainDevices"
                >
                  <div class="flex flex-row justify-start items-center">
                    <ng-container
                      *ngIf="getImageUri(installation, mainDevices) as imageUri; else hideImage"
                    >
                      <img class="image-margin" [src]="imageUri" />
                    </ng-container>
                    <ng-template #hideImage>
                      <mat-icon class="hide-image">hide_image</mat-icon>
                    </ng-template>
                    <div class="info">
                      <div class="description">
                        {{ getInstallationTitle(installation, mainDevices) }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="status flex xl:flex-row lt-xl:flex-col xl:justify-start xl:items-center"
                  >
                    <ng-container *ngFor="let gateway of installation.gateways">
                      <ng-container *ngIf="installation.isColdSystem">
                        <mat-icon class="cold-system-icon" [matTooltip]="coldSystemTooltip"
                          >cancel</mat-icon
                        >
                      </ng-container>
                      <ng-container [ngSwitch]="gateway?.aggregatedStatus">
                        <span
                          class="flex flex-row justify-center items-stretch"
                          matTooltip="{{ gateway?.aggregatedStatus | translateAggregatedStatus }}"
                        >
                          <mat-icon *ngSwitchCase="aggregatedStatus.Offline" class="offline-mode"
                            >wifi_off</mat-icon
                          >
                          <mat-icon
                            *ngSwitchCase="aggregatedStatus.WorksProperly"
                            class="works-properly-icon"
                            >check_circle
                          </mat-icon>
                          <mat-icon *ngSwitchCase="aggregatedStatus.Error" class="error-icon"
                            >error</mat-icon
                          >
                          <mat-icon
                            *ngSwitchCase="aggregatedStatus.Maintenance"
                            class="maintenance-icon"
                            >build</mat-icon
                          >
                        </span>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </ng-container>
      <!-- installation card -->
      <div
        [class.selected-installation-list-panel-container]="
          state.selectedInstallations && state.selectedInstallations.length > 1
        "
        [class.selected-installation-panel-container]="
          state.selectedInstallations && state.selectedInstallations.length === 1
        "
        *ngIf="state.selectedInstallations.length"
      >
        <div
          [class.selected-installation-list-panel]="state.selectedInstallations.length > 1"
          [class.selected-installation-panel]="state.selectedInstallations.length === 1"
        >
          <div *ngFor="let selectedInstallation of state.selectedInstallations">
            <div class="description">
              {{
                ('+INSTALLATIONS.INSTALLATIONS.INSTALLATION_OF' | translate) +
                  ' ' +
                  selectedInstallation?.ownerName
              }}
            </div>
            <div class="address">
              <div class="label">
                {{ '+INSTALLATIONS.MAP.LABEL.INSTALLATION_ADDRESS' | translate }}
              </div>
              <div>
                {{ selectedInstallation?.location }}
              </div>
            </div>
            <div *ngIf="state.selectedInstallations.length === 1" class="phone">
              <div class="label">{{ '+INSTALLATIONS.MAP.LABEL.TELEPHONE' | translate }}</div>
              <div *ngIf="installationDetailsStore.loading$ | async">...</div>
              <div *ngIf="!(installationDetailsStore.loading$ | async)">
                {{ (installationDetailsStore.owner$ | async)?.phone | formatPhoneNumber }}
              </div>
            </div>
            <div class="installation-details-link">
              <a
                gtm="onGoToPage"
                gtmAction="Installation"
                gtmCategory="map"
                routerLink="{{ '/installations/' + selectedInstallation.id }}"
              >
                <button mat-button color="primary">
                  {{ '+INSTALLATIONS.MAP.BUTTON.GO_TO_INSTALLATION' | translate }}
                </button>
              </a>
            </div>
          </div>
        </div>
        <div class="footer flex flex-row justify-end items-center">
          <button
            mat-button
            color="primary"
            gtm="onClose"
            gtmAction="Selected installation details"
            gtmCategory="map"
            (click)="mapStore.unselectInstallation()"
          >
            {{ 'GENERAL.BUTTON.CLOSE' | translate }}
          </button>
        </div>
      </div>
      <google-map
        [center]="mapCenter"
        [zoom]="state.zoom"
        [options]="{ mapTypeControl: false, minZoom: 3, maxZoom: 20 }"
      >
        <map-marker-clusterer [styles]="clusterStyle" [calculator]="calculateFunction">
          <map-marker
            *ngFor="let installation of state.searchedInstallations; trackBy: trackByIndex"
            (mapClick)="selectInstallation(installation)"
            [position]="{ lat: installation.latitude, lng: installation.longitude }"
            [options]="{ icon: getIconUrl(installation) }"
          ></map-marker>
        </map-marker-clusterer>
      </google-map>
    </div>
  </div>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
